export default function generateBlogBreadcrumbList(basePath, article = null) {
  const json = {
    "@context": "http://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement":
      [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Home",
          "item": `${basePath}/`
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "Blog",
          "item": `${basePath}/blog`
        },
      ]
  }

  if (article) {
    json.itemListElement.push({
      "@type": "ListItem",
      "position": 3,
      "name": article.title,
      "item": `${basePath}/blog/${article.link}`
    })
  }
  return JSON.stringify(json)
}
